import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import Autocomplete from "@mui/material/Autocomplete";
import { APP_BACKGROUND_COLOR,APP_COLOR, FONT_FAMILY, TEXT_COLOR } from "../../theme";

export const SelectField = styled(Autocomplete)({
  color: "white",
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      border: "0.5px solid rgba(0,0,0,0,0.2)",
      padding: "20px",
      height: "100%",
    },
    "&:hover fieldset": {
      borderColor: "#a6cfd5",
    },
    "&.Mui-focused fieldset": {
      borderColor: APP_COLOR,
    },
  },
});

export const styles = {
  userSearch: {
    width: "300px",
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: APP_COLOR,
    },
  } as const,
  outerContainer: {
    fontFamily: FONT_FAMILY,
    textAlign: "center",
    color: "white",
    marginBottom: 60,
    marginTop: "60px",
  } as const,
  noUserContainer: {
    height: "35vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  } as const,
  selectContainer: {
    display: "flex",
    margin: "auto",
    textAlign: "left",
    justifyContent: "center",
  } as const,
  gridBox: {
    border: "1px solid red",
    display: "grid",
    width: "80%",
    margin: "auto",
    gridTemplateColumns: {
      xs: "repeat(1,1fr)",
      sm: "repeat(2,1fr)",
      md: "repeat(4,1fr)",
      lg: "repeat(4,1fr)]",
    },
  } as const,
  label: {
    padding: 0,
    margin: 0,
    fontWeight: "bold",
  } as const,
  username: {
    marginTop: "20px",
    fontWeight: "bold",
  } as const,
  note: {
    fontWeight: "bold",
    fontSize: "25px",
    marginTop: "20px",
    fontFamily: "Argumentum",
  } as const,
  userInfo: {
    display: "flex",
    padding: "20px",
    color: "white",
    backgroundColor: APP_BACKGROUND_COLOR,
  } as const,
  userInfoLeftContainer: {
    width: "50%",
    display: "flex",
    justifyContent: "flex-start",
  } as const,
  userInfoRightContainer: {
    width: "50%",
    display: "flex",
    justifyContent: "flex-end",
  } as const,
  heading: {
    textAlign: "center",
    margin: "20px 0px 20px 0px",
    fontWeight: "bold",
    fontSize: "28px",
    fontFamily: FONT_FAMILY,
  } as const,
  featuredHeading: {
    textAlign: "left",
    margin: "10px 0px 10px 0px",
    borderBottom: "1px solid #cfcfcf",
    fontWeight: "bold",
    fontSize: "24px",
    fontFamily: FONT_FAMILY,
  } as const,
  textField: {
    width: "300px",
    border: "1px solid #b7b9c7",
    borderRadius: "5px",
  } as const,
  inputProps: {
    style: {
      height: "15px",
      border: "2px solid #b7b9c7",
      borderRadius: "5px",
      color: TEXT_COLOR,
    },
  } as const,
  selectField: {
    width: "300px",
    border: "blue",
    borderRadius: "5px",
    color: "white",
  } as const,
  cardContainer: {
    boxShadow: "none",
    borderRadius: "0",
    backgroundColor: APP_BACKGROUND_COLOR,
    color: "white",
    width: "100%",
  } as const,
  navLink: {
    textDecoration: "none",
    color: "black",
    margin: "auto",
    width: "100%",
  } as const,
  cardActionArea: {
    display: "inline-block",
    height: "400px",
    width: "100%",
    backgroundColor: APP_BACKGROUND_COLOR,
    overflow: "hidden",
  } as const,
  cardMedia: {
    display: "block",
    width: "100%",
    height: "400px",
    transition: "transform 2s",
    ":hover": {
      transform: "scale(1.1)",
    },
  } as const,
};

export const SelectContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  margin: "auto",
  textAlign: "left",
  justifyContent: "center",
  alignItems: "center",
  gap: "20px",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
  },
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
  },
}));
